import TagManager from 'react-gtm-module';
import {
  hasAnalyticsConsent,
  hasTargetingConsent,
  hasUserMadeConsentChoice,
  subscribeToConsentChanges,
} from './oneTrustConsent';

export { subscribeToConsentChanges };

let gtmInitialized = false;

export function shouldLoadGtm(): boolean {
  if (!hasUserMadeConsentChoice()) return false;
  return hasAnalyticsConsent() || hasTargetingConsent();
}

export function hasMarketingConsent(): boolean {
  return hasUserMadeConsentChoice() && hasTargetingConsent();
}

export function initializeGtmIfConsented(): boolean {
  if (gtmInitialized || !shouldLoadGtm()) return gtmInitialized;

  const gtmId = process.env.REACT_APP_GTM_ID;
  if (!gtmId) return false;

  TagManager.initialize({ gtmId });
  gtmInitialized = true;
  return true;
}

export function pushDataLayer(dataLayerArgs: {
  dataLayer: Record<string, unknown>;
}): void {
  if (!shouldLoadGtm()) return;

  if (!gtmInitialized) {
    initializeGtmIfConsented();
  }

  if (gtmInitialized) {
    TagManager.dataLayer(dataLayerArgs);
  }
}
